
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faChevronRight as farChevronRight,
    } from '@fortawesome/pro-regular-svg-icons/faChevronRight';

    import SeekerAvatar from '@/components/Seeker/SeekerAvatar';

    export default {
        name: 'HistogramSeekerNoDesiredPay',

        components: {
            SeekerAvatar,
            FontAwesomeIcon,
        },

        data() {
            return {
                icons: {
                    farChevronRight,
                },
            };
        },

        methods: {
            onClick() {
                this.$emit('click');
            },
        },
    };
